import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { StatusLabel } from '@components/StatusLabel'

class ProjectsTable extends Component {
  static propTypes = {
    projects: PropTypes.object,
    sidebarStore: PropTypes.object,
    projectsPipelineStore: PropTypes.object
  }

  renderProjects = () => {
    const { projects, sidebarStore } = this.props
    const projectRows = projects.map(project => {
      const atheneumContacts = project.atheneumContacts || '-'
      const associates = project.associates || '-'
      const target = project.target || '-'
      const delivered = project.delivered || '-'
      const interviewed = project.interviewed || '-'
      return (
        <tr key={project.id}>
          <td>
            <span
              className='row--link'
              onClick={() =>
                sidebarStore.openSidebar({
                  template: 'project',
                  id: project.id
                })
              }
            >
              {project.name}
            </span>
          </td>
          <td>
            <StatusLabel
              statusId={project.statusId}
              statusesType='projectStatuses'
            />
          </td>
          <td>
            <span>{project.clientContacts}</span>
          </td>
          <td>
            <span
              className='row--link'
              onClick={() =>
                sidebarStore.openSidebar({
                  template: 'client-account',
                  id: project.accountId
                })
              }
            >
              {project.accountCompanyName}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{project.startDate}</span>
          </td>
          <td>
            <span>{atheneumContacts}</span>
          </td>
          <td>
            <span>{associates}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {project.requested}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{target}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{delivered}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{interviewed}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{project.revenue}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{project.cost}</span>
          </td>
          <td>
            <span className='text-wrapper right-align'>{project.margin}</span>
          </td>
        </tr>
      )
    })
    return (
      <tbody>
        {projectRows}
        {this.renderTotalRow()}
      </tbody>
    )
  }

  renderTotalRow = () => {
    const {
      requestedSum,
      targetSum,
      deliveredSum,
      interviewedSum,
      revenueSum,
      costSum,
      totalMargin
    } = this.props.projectsPipelineStore

    return (
      <tr>
        <td>
          <span className='text-wrapper bold'>Total</span>
        </td>
        <td>
          <span className='text-wrapper' />
        </td>
        <td>
          <span className='text-wrapper' />
        </td>
        <td>
          <span className='text-wrapper' />
        </td>
        <td>
          <span className='text-wrapper' />
        </td>
        <td>
          <span className='text-wrapper' />
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{requestedSum}</span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{targetSum}</span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{deliveredSum}</span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>
            {interviewedSum}
          </span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{revenueSum}</span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{costSum}</span>
        </td>
        <td>
          <span className='text-wrapper right-align bold'>{totalMargin}</span>
        </td>
      </tr>
    )
  }

  render () {
    return (
      <table className='table-wrapper revenues'>
        <thead>
          <tr>
            <th>Project name</th>
            <th>Status</th>
            <th>Client contacts</th>
            <th>Client account</th>
            <th className='min-width'>Start date</th>
            <th>Atheneum contacts</th>
            <th>Associates</th>
            <th className='right-align'>Requested</th>
            <th className='right-align'>Target</th>
            <th className='right-align'>Delivered</th>
            <th className='right-align'>Interviewed</th>
            <th className='right-align'>Revenue (EUR)</th>
            <th className='right-align'>Cost (EUR)</th>
            <th className='right-align'>Margin</th>
          </tr>
        </thead>
        {this.renderProjects()}
      </table>
    )
  }
}

export default withRouter(
  inject('sidebarStore', 'projectsPipelineStore')(observer(ProjectsTable))
)
